// Client wrapper over the My Event CRUD endpoints + a shared reactive list.
// Endpoints return { event } on success or { conflict: { title } } when the
// event overlaps something already on My Schedule.
export const useMyEvents = () => {
    const events = useState('my-events', () => [])

    const loadEvents = async () => {
        const { events: rows } = await $fetch('/api/v1/schedule/events')
        events.value = rows || []
    }

    const createEvent = async (form) => {
        const res = await $fetch('/api/v1/schedule/events', { method: 'POST', body: form })
        if (res?.event) events.value = [...events.value, res.event]
        return res
    }

    const updateEvent = async (id, form) => {
        const res = await $fetch(`/api/v1/schedule/events/${id}`, { method: 'PATCH', body: form })
        if (res?.event) events.value = events.value.map((e) => (e.id === id ? res.event : e))
        return res
    }

    const deleteEvent = async (id) => {
        await $fetch(`/api/v1/schedule/events/${id}`, { method: 'DELETE' })
        events.value = events.value.filter((e) => e.id !== id)
    }

    const loadOptions = () => $fetch('/api/v1/schedule/event-options')

    return { events, loadEvents, createEvent, updateEvent, deleteEvent, loadOptions }
}
